import React, { useEffect, useState } from "react";
import {
  MDBFile,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCheckbox,
  MDBValidation,
  MDBTextArea,
  MDBBtn,
  MDBInput,
} from "mdb-react-ui-kit";
import axios from "axios";
import { getCurrentDate } from "../utilities/getCurrentDate";
import { useSelector } from "react-redux";
import { validateNewAdvocateData } from "../utilities/validateNewAdvocateData";
import { toast } from "react-toastify";

import API_BASE_URL from "../utilities/apiConfig";
import axiosInstance from "../utilities/apiConfig";

const NewAdvocateEntry = () => {
  const newUserCreationInitialState = {
    name: "",
    relationshipType: "",
    relativeName: "",
    advocateBarId: "",
    // advocateAlternateBarId: '',
    mobileno: "",
    userId: "",
    concernedBarRegistrationDate: "",
    dateOfBirth: "",
    // mobileno2: '',
    email: "",
    // experienceIn: '',
    // yearOfExperience: "",
    permanentAddress: "",
    // localAddress: '',
    // membershipFeesTypeId: ""
  };

  const [relationships, setRelationships] = useState([]);
  const [newAdvocateDetails, setNewAdvocateDetails] = useState(
    newUserCreationInitialState
  );

  const userDeatils = useSelector((state) => state.auth?.userData?.authUser);
  const { userId } = userDeatils;
  const token = useSelector((state) => state.auth.token);

  const fetchRelationships = async () => {
    try {
      const response = await axiosInstance.get(`/Master/get_relations`);
      setRelationships(response.data);
      console.log("Relations Response from Verification", response.data);
    } catch (error) {
      console.error("Error fetching relationships:", error);
    }
  };

  const handleSubmitNewAdvocateEntry = async (e) => {
    e.preventDefault();

    const errors = validateNewAdvocateData(newAdvocateDetails);
    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((error) => {
        toast.error(error);
      });
      return;
    }

    try {
      const response = await axiosInstance.post(
        `/Verification/create_new_advocate_entry`,
        {
          ...newAdvocateDetails,
          userId: userId,
        },
        {
          headers: {
            "Content-Type": "application/problem+json; charset=utf-8",
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );

      console.log("API Response:", response.data);
      if (response.data.response.statusCode === 200) {
        toast.success(response.data.response.status);
        setNewAdvocateDetails(newUserCreationInitialState);
      } else {
        toast.error(response.data.response.status);
      }
    } catch (error) {
      console.error("Error submitting advocate details:", error);
      toast.error("Error submitting advocate details");
    }
  };

  useEffect(() => {
    fetchRelationships();
  }, []);

  const handleInputFieldChange = (e) => {
    const { name, value } = e.target;
    setNewAdvocateDetails({ ...newAdvocateDetails, [name]: value });
  };

  return (
    <>
      <div className="row justify-content-center mb-4 mt-5">
        <div className="col-xxl-8">
          <div className="row">
            <h3>New Details Entry of Advovcate</h3>
          </div>
        </div>
      </div>

      <div className="row justify-content-center mb-4 mt-5">
        <div className="col-xxl-8">
          <div className="row">
            <div
              invalid
              feedback="Please provide a valid Bar Id."
              className="col-sm-6 col-md-4 col-xl-3 align-self-end"
            >
              <MDBInput
                required
                label="Enter Bar Id"
                id="advocateBarId"
                name="advocateBarId"
                value={newAdvocateDetails?.advocateBarId}
                onChange={(e) => {
                  handleInputFieldChange(e);
                }}
                type="text"
                className="mb-0"
              />
            </div>

            <div
              invalid
              feedback="Please provide a valid name."
              className="col-sm-6 col-md-4 col-xl-3 align-self-end"
            >
              <MDBInput
                required
                label="Enter Name"
                id="name"
                name="name"
                value={newAdvocateDetails?.name}
                onChange={(e) => {
                  handleInputFieldChange(e);
                }}
                type="text"
                className="mb-0"
              />
            </div>

            <div className="col-sm-6 col-md-5 col-xl-4 align-self-end">
              <div className="input-group mb-0">
                <select
                  className="form-select form-select-sm py-0 "
                  style={{
                    height: "calc(1.5em + 0.75rem + 2px)",
                    width: "30%",
                  }}
                  onChange={handleInputFieldChange}
                  value={newAdvocateDetails?.relationshipType}
                  name="relationshipType"
                  id="relationshipType"
                  required // This makes the select field required
                >
                  <option value="#" selected>
                    select
                  </option>
                  {relationships.map((item, key) => (
                    <option key={key} value={item.relationshipType}>
                      {item.relationshipSymbol.toUpperCase()}
                    </option>
                  ))}
                </select>

                <div className="input-group-append" style={{ width: "70%" }}>
                  <MDBInput
                    required
                    label="Relative Name"
                    id="relativeName"
                    name="relativeName"
                    value={newAdvocateDetails?.relativeName}
                    onChange={handleInputFieldChange}
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center mb-3">
        <div
          feedback="Please provide a valid city."
          invalid
          className="col-sm-6 col-md-3 col-xxl-2"
        >
          <MDBInput
            required
            label="Mobile No"
            id="mobileno"
            name="mobileno"
            value={newAdvocateDetails?.mobileno}
            onChange={(e) => {
              handleInputFieldChange(e);
            }}
            type="number"
          />
        </div>
        <div className="col-sm-6 col-md-3 col-xxl-2">
          <MDBInput
            label="Email"
            id="email"
            name="email"
            value={newAdvocateDetails?.email}
            onChange={(e) => {
              handleInputFieldChange(e);
            }}
            type="email"
          />
        </div>

        <div className="col-sm-6 col-md-3 col-xxl-2">
          <MDBInput
            required
            label="Dehradun Bar Reg Year"
            id="concernedBarRegistrationDate"
            name="concernedBarRegistrationDate"
            min="1960-01-01"
            max={getCurrentDate()}
            value={newAdvocateDetails?.concernedBarRegistrationDate}
            onChange={(e) => {
              handleInputFieldChange(e);
            }}
            type="date"
          />
        </div>

        <div className="col-sm-6 col-md-3 col-xxl-2">
          <MDBInput
            required
            label="Date of Birth"
            id="dateOfBirth"
            name="dateOfBirth"
            min="1947-01-01"
            max={getCurrentDate()}
            value={newAdvocateDetails?.dateOfBirth}
            onChange={(e) => {
              handleInputFieldChange(e);
            }}
            type="date"
          />
        </div>
      </div>

      {/* <div className="row justify-content-center mb-2">
                <div className="col-xxl-8">
                    <div className="row">
                        <div className="col-sm-6 col-md-4 col-xl-3">
                            <MDBInput
                                label="Second Mobile No"
                                id="mobileno2"
                                name="mobileno2"
                                value={newAdvocateDetails?.mobileno2}
                                onChange={(e) => {
                                    handleInputFieldChange(e);
                                }}
                                type="number"

                            />
                        </div>

                        <div className="col-sm-6 col-md-4 col-xl-3">
                            <MDBInput
                                label="Alternate Bar Id"
                                id="advocateAlternateBarId"
                                name="advocateAlternateBarId"
                                value={newAdvocateDetails?.advocateAlternateBarId}
                                onChange={(e) => {
                                    handleInputFieldChange(e);
                                }}
                                type="text"

                            />
                        </div>

                        <div className="col-sm-6 col-md-4 col-xl-3">
                            <MDBInput required
                                label="Experience in"
                                id="experienceIn"
                                name="experienceIn"
                                value={newAdvocateDetails?.experienceIn}
                                onChange={(e) => {
                                    handleInputFieldChange(e);
                                }}
                                type="text"
                            />
                        </div>
                        <div className="col-sm-6 col-md-4 col-xl-3">
                            <MDBInput required
                                label="Year of Experience"
                                id="yearOfExperience"
                                name="yearOfExperience"
                                value={newAdvocateDetails.yearOfExperience}
                                onChange={(e) => {
                                    handleInputFieldChange(e);
                                }}
                                type="number"
                            />
                        </div>



                    </div>
                </div>
            </div> */}

      {/* <div className="row justify-content-center mb-2">
                <div className="col-xxl-8">
                    <div className="row">
                        <div className="col-sm-6 col-md-4 col-xl-3">
                            <MDBInput
                                label="Second Mobile No"
                                id="mobileno2"
                                name="mobileno2"
                                value={newAdvocateDetails?.mobileno2}
                                onChange={(e) => {
                                    handleInputFieldChange(e);
                                }}
                                type="number"

                            />
                        </div>

                        <div className="col-sm-6 col-md-4 col-xl-3">
                            <MDBInput
                                label="Alternate Bar Id"
                                id="advocateAlternateBarId"
                                name="advocateAlternateBarId"
                                value={newAdvocateDetails?.advocateAlternateBarId}
                                onChange={(e) => {
                                    handleInputFieldChange(e);
                                }}
                                type="text"

                            />
                        </div>

                        <div className="col-sm-6 col-md-4 col-xl-3"  >
                            <MDBInput required
                                label="Dehradun Bar Reg Year"
                                id="concernedBarRegistrationDate"
                                name="concernedBarRegistrationDate"
                                min="1960-01-01" max={getCurrentDate()}
                                value={newAdvocateDetails?.concernedBarRegistrationDate}
                                onChange={(e) => {
                                    handleInputFieldChange(e);
                                }}

                                type="date"

                            />

                        </div>

                        <div className="col-sm-6 col-md-4 col-xl-3">
                            <MDBInput required
                                label="Date of Birth"
                                id="dateOfBirth"
                                name="dateOfBirth"
                                min="1947-01-01" max={getCurrentDate()}
                                value={newAdvocateDetails?.dateOfBirth}
                                onChange={(e) => {
                                    handleInputFieldChange(e);
                                }}
                                type="date"

                            />
                        </div>


                    </div>
                </div>
            </div> */}

      {/* <div className="row justify-content-center mb-2 mt-4">
                <div className="col-xxl-8">
                    <div className="row">
                        <div className="col-sm-6 col-md-4 col-xl-3">

                            <select
                                className="form-select form-select-sm py-0 "
                                style={{ height: "calc(1.5em + 0.75rem + 2px)", width: "100%" }}
                                onChange={handleInputFieldChange}
                                value={newAdvocateDetails?.membershipFeesTypeId}
                                name="membershipFeesTypeId"
                                id="membershipFeesTypeId"
                                required // This makes the select field required
                            >
                                <option value="" selected>Select Membership Type</option>
                                <option value="1" >Yearly</option>
                                <option value="2" >Lifetime</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div> */}

      {/* <div className="row justify-content-center mb-2">
                <div className="col-xxl-8">
                    <div data-mdb-input-init className="form-outline">
                        <label className="form-label" htmlFor="textAreaExample3">
                            Current Address
                        </label>
                        <MDBTextArea required
                            className="form-control"
                            id="localAddress"
                            name="localAddress"
                            value={newAdvocateDetails?.localAddress}
                            onChange={(e) => {
                                handleInputFieldChange(e);
                            }}
                            rows="2"
                        ></MDBTextArea>
                    </div>
                </div>
            </div> */}

      <div className="row justify-content-center mb-2">
        <div className="col-xxl-8">
          <div data-mdb-input-init className="form-outline">
            <label className="form-label" htmlFor="textAreaExample3">
              Permanent Address
            </label>
            <MDBTextArea
              required
              className="form-control"
              id="permanentAddress"
              name="permanentAddress"
              value={newAdvocateDetails?.permanentAddress}
              onChange={(e) => {
                handleInputFieldChange(e);
              }}
              rows="2"
            ></MDBTextArea>
          </div>
        </div>
      </div>

      <div className="row justify-content-center mb-2 mt-4">
        <div className="col-xxl-8 d-flex justify-content-center">
          <MDBBtn
            onClick={(e) => {
              handleSubmitNewAdvocateEntry(e);
            }}
          >
            Submit
          </MDBBtn>
        </div>
      </div>
    </>
  );
};

export default NewAdvocateEntry;
